import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { AuthRoute } from './AuthRoute'
import { NotFoundPage } from 'main/pages/exceptions/notFound'
import { ForgotPasswordPage } from 'main/pages/user/forgotPassword'
import { ResetPasswordPage } from 'main/pages/user/reset'
import { InnerPage } from 'main/pages/defaults/InnerPage'
import { IndexPage } from 'main/pages/user/login'
import { MarketplacePage } from 'main/pages/hotsite/marketplace'
import { EventsPage } from 'main/pages/hotsite/eventsPage'
import ScrollToTop from './ScrollToTop'
import { HotsiteInnerPage } from 'main/pages/defaults/HotsiteInnerPage'
import { HotsiteContactPage } from 'main/pages/hotsite/contact'
import { ROUTES } from 'sharedKernel/constants'
import { HotsiteEvaluatorRegisterPage } from 'main/pages/hotsite/register/evaluator'
import { HotsiteResolverRegisterPage } from 'main/pages/hotsite/register/resolver'
import { hubRoutes } from './hub'
import { HotsiteChallengePage } from 'main/pages/hotsite/challenge'
import { HotsiteEventPage } from 'main/pages/hotsite/event'
import { initializeGA, logPageView } from 'components/GoogleAnalytics/GAInitializer'
import { HotsiteSimplifiedResolverRegisterPage } from 'main/pages/hotsite/register/simplifiedResolver'
import { HotsiteCaixaEmployeeRegisterPage } from 'main/pages/hotsite/register/caixaEmployee'
import { HotsitePublicAdministrationRegisterPage } from 'main/pages/hotsite/register/publicAdministration'
import {initializeClarity} from "../components/Clarity/Clarity";
import { PublicMeetingRoomReservationPage } from 'main/pages/public/meeting-room-reservation'
import { useLegacyLoadGate, useSmartNavInterceptor } from 'components/SmartLink'

export const RoutesBuilder = (): JSX.Element => {
  const location = useLocation()

  // Globally intercept in-app anchor clicks (hotsite + hub). In flag-aware mode only
  // shell-owned routes bounce to the shell; legacy routes navigate natively.
  useSmartNavInterceptor()
  // Flag-aware on-load gate: a direct legacy load of a shell-owned+activated route bounces
  // to the shell; otherwise renders in place. Inert pre-login (no token ? no flags ? no bounce)
  // and when REACT_APP_SMARTNAV_PRELOAD is off.
  useLegacyLoadGate()

  useEffect(() => {
    initializeGA()
    initializeClarity()
  }, [])

  useEffect(() => {
    logPageView()
  }, [location])

  return (
    <ScrollToTop>
      <Routes>
        <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
        {/* Hotsite */}
        <Route path={ROUTES.HOTSITE.ROOT} element={<HotsiteInnerPage></HotsiteInnerPage>}>
          <Route path={ROUTES.HOTSITE.ROOT}  />
          <Route path={ROUTES.HOTSITE.MARKETPLACE} element={<MarketplacePage />} />
          <Route path={ROUTES.HOTSITE.EVENTS_PAGE} element={<EventsPage />} />
          <Route path={ROUTES.HOTSITE.CHALLENGE} element={<HotsiteChallengePage />} />
          <Route path={ROUTES.HOTSITE.EVENT} element={<HotsiteEventPage />} />
          <Route path={ROUTES.HOTSITE.REGISTER.EVALUATOR} element={<HotsiteEvaluatorRegisterPage />} />
          <Route path={ROUTES.HOTSITE.REGISTER.RESOLVER} element={<HotsiteResolverRegisterPage />} />
          <Route path={ROUTES.HOTSITE.REGISTER.SIMPLIFIED_RESOLVER} element={<HotsiteSimplifiedResolverRegisterPage />} />
          <Route path={ROUTES.HOTSITE.REGISTER.RESOLVER_CONNECTION} element={<HotsiteResolverRegisterPage />} />
          <Route path={ROUTES.HOTSITE.REGISTER.CAIXA_EMPLOYEE} element={<HotsiteCaixaEmployeeRegisterPage />} />
          <Route path={ROUTES.HOTSITE.REGISTER.PUBLIC_ADMINISTRATION} element={<HotsitePublicAdministrationRegisterPage />} />
          <Route path={ROUTES.HOTSITE.CONTACT} element={<HotsiteContactPage />} />
          <Route path={ROUTES.HOTSITE.LANDINGPAGE} element={<NotFoundPage />} />
        </Route>

        <Route
          path={ROUTES.PUBLIC.MEETING_ROOM_RESERVATION}
          element={<PublicMeetingRoomReservationPage />}
        />

        <Route path={ROUTES.USER_AUTH.LOGIN} element={<IndexPage />} />
        <Route path={ROUTES.USER_AUTH.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route path={ROUTES.USER_AUTH.RESET_PASSWORD} element={<ResetPasswordPage />} />

        {/* HUB */}
        <Route path={ROUTES.HUB.ROOT} element={<InnerPage></InnerPage>}>
          {hubRoutes.map((route, index) => {
            return (<AuthRoute key={index} path={route.path} features={route.features} element={route.component} />)
          })}
        </Route>
      </Routes>
    </ScrollToTop>
  )
}

export const CreateRoutes = (): JSX.Element => {
  return (
    <BrowserRouter>
      <RoutesBuilder />
    </BrowserRouter>
  )
}
